module.exports = __webpack_public_path__ + "static/media/front desk (HR).19ef0648.svg";